export var InsightVariantType;
(function (InsightVariantType) {
    /**
     * @deprecated will be removed, do not use it
     */
    InsightVariantType["DEFAULT"] = "DEFAULT";
    InsightVariantType["REGULAR"] = "REGULAR";
    InsightVariantType["WITH_IMAGE"] = "WITH_IMAGE";
})(InsightVariantType || (InsightVariantType = {}));
//# sourceMappingURL=insightVariantType.js.map